export default __webpack_public_path__ + "locales/az/Files.json?hash=73538175885b46d1f4c51626bfa424af";